import { render, staticRenderFns } from "./ProjectScopeTemplate.vue?vue&type=template&id=71ae67cc&scoped=true"
import script from "./ProjectScopeTemplate.vue?vue&type=script&lang=js"
export * from "./ProjectScopeTemplate.vue?vue&type=script&lang=js"
import style0 from "./ProjectScopeTemplate.vue?vue&type=style&index=0&id=71ae67cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae67cc",
  null
  
)

export default component.exports